/// <amd-module name="Search/Wiki/Flux/Sources/CountSpy" />
import { ActionsHub } from "Search/Wiki/Flux/ActionsHub";
import { EntityTypeUrlParam } from "Search/Wiki/Constants";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub2";
import { WikiSearchRequest, WikiSearchResponse, WikiResult } from "Search/WebApi/Contracts/Search.Shared";
import { PivotResults } from "Search/Shared/Base/Types";
import { RelationFromExactCount } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";

export class CountSpy {
    constructor(
        private readonly resultsCount: PivotResults,
        private readonly actionsHub: ActionsHub) {
        this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.addListener(this.onResultsLoaded);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.removeListener(this.onResultsLoaded);
    }

    private onResultsLoaded = ({ response }: IResultsLoadedPayload<WikiSearchRequest, WikiSearchResponse, WikiResult>): void => {
        setTimeout(() => { 
            this.resultsCount[EntityTypeUrlParam].value = { count: response.count, relationFromExactCount: RelationFromExactCount.Equals};
        }, 0);
    }
}
